import { useTranslation } from 'react-i18next'

import { ConfigRow } from '../../display/ConfigRow'

import { Badge, Button, Flex } from '@percent/lemonade'

type BooleanToggleRowProps = {
  id: string
  label: string
  tooltip?: string
  isLoading: boolean
  isSaving: boolean
  error?: string
  enabled: boolean
  onToggle: () => void
}

export function BooleanToggleRow({
  id,
  label,
  tooltip,
  isLoading,
  isSaving,
  error,
  enabled,
  onToggle
}: BooleanToggleRowProps) {
  const { t } = useTranslation()

  return (
    <ConfigRow id={id} label={label} tooltip={tooltip} isLoading={isLoading} error={error}>
      <Flex align="center" gap={4}>
        <Badge variant={enabled ? 'positive' : 'default'}>
          {enabled ? t('typography.enabled') : t('typography.disabled')}
        </Badge>
        {/* Gated on the global save lock like every EditableConfigRow Save — without this the
            toggle is the one control that can fire a second mutation mid-save and clobber the
            in-flight refresh/callback refs (see usePartnerGivingConfigs single-mutation note). */}
        <Button variant="secondary" size="small" onClick={onToggle} disabled={isSaving}>
          {enabled ? t('partnerConfig.action.disable') : t('partnerConfig.action.enable')}
        </Button>
      </Flex>
    </ConfigRow>
  )
}
